export default __webpack_public_path__ + "static/media/Clocktower.c5d05bc5.jpg";